import React, { createContext, useContext, useState, useEffect } from 'react';
import { categoriesApi } from '../services/api';
import { useLocalization } from './LocalizationContext';

const CategoriesContext = createContext();

export const useCategories = () => {
  const context = useContext(CategoriesContext);
  if (!context) {
    throw new Error('useCategories must be used within CategoriesProvider');
  }
  return context;
};

export const CategoriesProvider = ({ children }) => {
  const { countryCode } = useLocalization();
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (countryCode) {
      fetchCategories();
    }
  }, [countryCode]);

  const fetchCategories = async () => {
    try {
      setLoading(true);
      const data = await categoriesApi.getAll(true, countryCode);
      setCategories(data);
      setError(null);
    } catch (err) {
      console.error('Error fetching categories:', err);
      setError(err);
      setCategories([]);
    } finally {
      setLoading(false);
    }
  };

  // Helper function to get parent categories only
  const getParentCategories = () => {
    return categories.filter(cat => !cat.parentId);
  };

  // Helper function to get categories by parent
  const getCategoriesByParent = (parentId) => {
    return categories.filter(cat => cat.parentId === parentId);
  };

  const value = {
    categories,
    loading,
    error,
    refetch: fetchCategories,
    getParentCategories,
    getCategoriesByParent
  };

  return (
    <CategoriesContext.Provider value={value}>
      {children}
    </CategoriesContext.Provider>
  );
};

export default CategoriesContext;
